<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['articleTitle']" placeholder="请输入标题"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="类型 医馆0，文章1" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['articleType']" placeholder="请输入类型 医馆0，文章1"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="伪删除 正常0，删除1" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['invalid']" placeholder="请输入伪删除 正常0，删除1"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="阅读量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['readingTotal']" placeholder="请输入阅读量"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标题图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload isMultiple v-decorator="['headImg']"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="审核状态 0 未上线，1上线，2定时" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['status']" placeholder="请输入审核状态 0 未上线，1上线，2定时"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="置顶时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择置顶时间" v-decorator="['makeTopTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="文章内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['articleContentString',{trigger:'input'}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="类型 图文0，视频1，患者讲述2，医生说3，专栏4" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['type']" placeholder="请输入类型 图文0，视频1，患者讲述2，医生说3，专栏4"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="下载 不允许0，允许1" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['allowdDown']" placeholder="请输入下载 不允许0，允许1"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="上架状态，0立即上架，1定时上架暂定上架" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['isShelvesStatus']" placeholder="请输入上架状态，0立即上架，1定时上架暂定上架"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JEditor from '@/components/jeecg/JEditor'

  export default {
    name: 'ArticleSetForm',
    components: {
      JFormContainer,
      JDate,
      JImageUpload,
      JEditor,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/articleSet/articleSet/add",
          edit: "/articleSet/articleSet/edit",
          queryById: "/articleSet/articleSet/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'articleTitle','articleType','invalid','readingTotal','headImg','status','makeTopTime','articleContentString','type','allowdDown','isShelvesStatus'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'articleTitle','articleType','invalid','readingTotal','headImg','status','makeTopTime','articleContentString','type','allowdDown','isShelvesStatus'))
      },
    }
  }
</script>